import React from "react";

import { Props } from "./types";
import icon from "./icon.svg";

function TransferIcon({ className }: Props) {
  return <img src={`${icon}#icon`} className={className} />;
}

export { TransferIcon };
